<template>
<div class="item-base" v-if="BottomLeft.photoList">
  <el-image :src="'http://'+ BottomLeft.photoList[0].address" class="img" fit="cover"></el-image>
</div>
</template>

<script>
export default {
  name: "ProductBottom",
  props:{
    BottomLeft:{

    }
  }
}
</script>

<style lang="less" scoped>
.item-base{
  width: 100%;

  height: 18.5vh;
  background: #F2F3F6;
  .img{
    width: 100%;
    height: 100%;
  }
}
</style>